import { formatPrice } from "constants/massages";

const TRAVEL_CENTS = 3900;
const WAKEUP_UNIT_CENTS = 500;
const CLASSIC_UNIT_CENTS = 2900;
const INTENSE_30_CENTS = 7000;
const INTENSE_60_CENTS = 12500;

export const SHOP_PRODUCTS = [
  {
    id: "wakeup",
    title: "Wake-Up",
    subtitle: "Schnelle Energie für deinen Tag",
    description:
      "Unsere Wake-up-Massage ist die schnelle 4-in-1-Aktivierung für deinen Körper. Sie fördert die Durchblutung, löst Verspannungen, unterstützt die Regeneration und verbessert die Beweglichkeit. Ideal, wenn du schnell neue Energie brauchst.",
    priceLabel: "ab 5 €",
    priceNote: "p. P.",
    asksPersonCount: true,
  },
  {
    id: "classic",
    title: "Classic",
    subtitle: "Ganzkörper-Energie für deine Woche",
    description:
      "Unsere Classic-Massage ist die gezielte Ganzkörpermassage für nachhaltige Erholung und neue Energie. Mit der perkussiven Massage werden Verspannungen und Verklebungen im gesamten Körper intensiv bearbeitet, die Durchblutung gefördert und die Regeneration unterstützt. Nach einer kurzen Erholungsphase fühlt sich der Körper wieder freier, beweglicher und voller Energie an – ideal für einen ausgeglichenen Energiefluss durch die ganze Woche.",
    priceLabel: "29 €",
    priceNote: "/ 10 Min.",
    spotlight: "Meist gebucht",
  },
  {
    id: "intense",
    title: "Intense",
    subtitle: "Neue Energie für dein Leben",
    description:
      "1 Stunde. 1 Trainer. 100 % individuell. Intense ist deine persönliche Dr.-Hoffmann-Begleitung – im Hotel, im Studio oder draußen. Ein erfahrener Trainer geht individuell auf dich ein: mit Bewegung, Stretching, Entspannung, Perkussionsmassage oder Beratung zu Training, Essen, Trinken und Regeneration. Genau das, was dein Körper gerade braucht.",
    priceLabel: "ab 70 €",
    priceNote: "/ 30 Min.",
    asksDuration: true,
    durationOptions: [30, 60],
  },
];

const serviceKeyFor = (massageType, delivery) => {
  const onsite = delivery === "onsite";
  if (massageType === "wakeup") {
    return onsite ? "dr-hoffmann-wakeup-onsite" : "dr-hoffmann-wakeup-studio";
  }
  if (massageType === "classic") {
    return onsite ? "dr-hoffmann-classic-onsite" : "dr-hoffmann-classic-studio";
  }
  return onsite ? "dr-hoffmann-premium-onsite" : "dr-hoffmann-premium-studio";
};

export const quoteShopVoucher = ({
  massageType,
  delivery = "studio",
  personCount = 1,
  durationMinutes = 60,
}) => {
  const product = SHOP_PRODUCTS.find((item) => item.id === massageType);
  if (!product || (delivery !== "studio" && delivery !== "onsite")) return null;
  const onsite = delivery === "onsite";
  const travelCents = onsite ? TRAVEL_CENTS : 0;
  let count = 1;
  let minutes = 10;
  let serviceCents = 0;

  if (massageType === "wakeup") {
    count = Number(personCount);
    if (!Number.isInteger(count) || count < 1 || count > 10) return null;
    minutes = count * 5;
    serviceCents = count * WAKEUP_UNIT_CENTS;
  } else if (massageType === "classic") {
    minutes = 10;
    serviceCents = CLASSIC_UNIT_CENTS;
  } else {
    minutes = Number(durationMinutes);
    if (minutes !== 30 && minutes !== 60) return null;
    serviceCents = minutes === 30 ? INTENSE_30_CENTS : INTENSE_60_CENTS;
  }

  const place = onsite ? "vor Ort" : "im Studio";
  const detail =
    massageType === "classic"
      ? "10 Min."
      : massageType === "intense"
        ? `${minutes} Min.`
        : `${count} ${count === 1 ? "Person" : "Personen"}`;

  return {
    massageType,
    delivery,
    personCount: count,
    durationMinutes: minutes,
    serviceKey: serviceKeyFor(massageType, delivery),
    priceCents: serviceCents + travelCents,
    travelCents,
    label: `${product.title} ${place} · ${detail}`,
  };
};

export const formatVoucherCodeInput = (value) =>
  String(value || "")
    .replace(/\D/g, "")
    .slice(0, 16)
    .replace(/(\d{4})(?=\d)/g, "$1-");

export const voucherMatchesSelection = (
  voucher,
  { serviceKey, personCount, durationMinutes }
) => {
  if (!voucher || voucher.status !== "redeemed") return false;
  if (voucher.serviceKey !== serviceKey) return false;
  if (voucher.massageType === "intense") {
    return Number(voucher.durationMinutes) === Number(durationMinutes);
  }
  if (voucher.massageType === "classic") return true;
  return Number(voucher.personCount) === Math.max(1, Number(personCount) || 1);
};

export const formatShopPrice = formatPrice;

const bookingOptionIdForVoucher = (voucher) => {
  const base =
    voucher?.massageType === "intense"
      ? "premium"
      : voucher?.massageType === "classic"
        ? "classic"
        : voucher?.massageType === "wakeup"
          ? "wakeup"
          : "";
  if (!base) return "";
  return voucher.delivery === "onsite" ? `${base}-onsite` : base;
};

/** Booking URL with the voucher's massage, place, and extras already chosen. */
export const bookingPathForVoucher = (voucher) => {
  const option = bookingOptionIdForVoucher(voucher);
  if (!option) return "/buchen";
  const params = new URLSearchParams();
  params.set("option", option);
  if (voucher.massageType === "wakeup" && Number(voucher.personCount) > 0) {
    params.set("persons", String(voucher.personCount));
  }
  if (voucher.massageType === "intense" && Number(voucher.durationMinutes) > 0) {
    params.set("duration", String(voucher.durationMinutes));
  }
  if (voucher.id) params.set("voucher", String(voucher.id));
  return `/buchen?${params.toString()}`;
};
